var STATES = [
  "AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG",
  "PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO",
];

export default function ProfileStep1({ form, updateField, brokers }) {
  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-500 mb-3">Preencha os dados abaixo para completar seu cadastro.</p>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Email <span className="text-red-500">*</span></label>
        <input type="email" value={form.email} onChange={function(e) { updateField("email", e.target.value); }}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
          placeholder="seu@email.com" data-testid="profile-email" />
        <p className="text-[10px] text-gray-400 mt-0.5">Obrigatorio para receber notificacoes e documentos</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Telefone</label>
          <input type="tel" value={form.phone} onChange={function(e) { updateField("phone", e.target.value); }}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
            placeholder="(11) 99999-9999" data-testid="profile-phone" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">CPF</label>
          <input type="text" value={form.cpf} onChange={function(e) { updateField("cpf", e.target.value); }}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
            placeholder="000.000.000-00" data-testid="profile-cpf" />
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">CNPJ <span className="text-gray-400 text-[10px]">(Pessoa Juridica)</span></label>
        <input type="text" value={form.cnpj} onChange={function(e) { updateField("cnpj", e.target.value); }}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
          placeholder="00.000.000/0000-00" data-testid="profile-cnpj" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Tipo de Conta</label>
          <select value={form.account_type || "pf"} onChange={function(e) { updateField("account_type", e.target.value); }}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6] bg-white"
            data-testid="profile-account-type">
            <option value="pf">Pessoa Física (PF)</option>
            <option value="pj">Pessoa Jurídica (PJ)</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Data de Nascimento</label>
          <input type="date" value={form.birth_date} onChange={function(e) { updateField("birth_date", e.target.value); }}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
            data-testid="profile-birth-date" />
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Endereco</label>
        <input type="text" value={form.address} onChange={function(e) { updateField("address", e.target.value); }}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
          placeholder="Rua, numero, complemento" data-testid="profile-address" />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Cidade</label>
          <input type="text" value={form.city} onChange={function(e) { updateField("city", e.target.value); }}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
            placeholder="Cidade" data-testid="profile-city" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Estado</label>
          <select value={form.state} onChange={function(e) { updateField("state", e.target.value); }}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6] bg-white"
            data-testid="profile-state">
            <option value="">UF</option>
            {STATES.map(function(s) { return <option key={s} value={s}>{s}</option>; })}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">CEP</label>
          <input type="text" value={form.cep} onChange={function(e) { updateField("cep", e.target.value); }}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
            placeholder="00000-000" data-testid="profile-cep" />
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Corretor Responsavel</label>
        <select value={form.broker_id} onChange={function(e) { updateField("broker_id", e.target.value); }}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6] bg-white"
          data-testid="profile-broker">
          <option value="">Selecione seu corretor</option>
          {brokers.map(function(b) { return <option key={b.id} value={b.id}>{b.name}</option>; })}
        </select>
      </div>
    </div>
  );
}
